<template>
<!-- class="tbp" :style="{ isGroup ? 'padding-top: 1.2rem' : '' }" -->
  <div  :class="[isGroup ? 'tbp' : 'tbpIn']">
    <!-- <container ref="DOMcontainer" @loadBottom="loadBottom"> -->
      <div class="list" v-if="isGroup">
        <ul>
          <li :class="{ 'active': currentIndex === 0 }" @click="clickCurrent(0)"><span>团体记录</span></li>
          <li :class="{ 'active': currentIndex === 1 }" @click="clickCurrent(1)"><span>散客记录</span></li>
        </ul>
      </div>
      <div class="listContent" v-if="invoiceData.length != 0">
        <div class="item" v-for="item in invoiceData" :key="item.id">
          <!-- 预留代码 @click="toDetail" -->
          <div class="content">
            <div class="firstrow">
              <div class="createtime">{{item.applyTime}}</div>
              <div class="status">
                <span>{{item.applyStatusName}}</span>
                <img src="~@/assets/image/invoice/myinvoice/arrow.png">
              </div>
            </div>
            <div class="secondrow">
              <div class="ticket">
                <span class="invoice"><i>{{item.invoiceTypeName}}</i></span>
                <span class="park-ticket">公园门票</span>
              </div>
              <div class="price">￥{{item.totalAmount}}</div>
            </div>
          </div>
          <div class="option">
            <div class="empty"></div>
            <div class="button-group">
              <!-- 目前后端代码暂不支持下面2个功能，待后端功能完善后在补充逻辑 -->
              <!-- <button @click="clickDetails(item)">重发发票</button> -->
              <!-- <button @click="clickDetails(item)">申请重开</button> -->
              <button @click="reTrySubmit(item)" v-if="item.canErrorApply == 'true'">再次提交</button>
              <button @click="toChangeInvoice(item)" v-if="item.canReApply == 'true'">重开申请</button>
              <button @click="toDetail(item.id)">查看详细</button>
              <button v-if="item.spUrl && item.invoiceType == '2'" @click="searchInvoice(item.spUrl,2)">查看发票</button>
              <button v-if="item.pdfUrl && item.invoiceType == '3'" @click="searchInvoice(item.pdfUrl,3)">下载发票</button>
            </div>
          </div>
        </div>
        <div id="loadMore" v-show="loadMore">正在加载...</div><!-- 第一次加载数据 -->
        <div id="loadMoreing" v-show="loadMoreing">正在加载...</div><!-- 上拉加载数据 -->
        <!-- <div id="noMoreData" v-show="loadMore?false:!loadMoreing">已加载全部</div> -->
        <!-- 所有数据加载完成 -->
      </div>
      <emptyContent text="您没有历史开发票记录" v-else />
      <div class="bottom">
        <div class="continue" @click="toMakeInvoice">开发票</div>
      </div>
    <!-- </container> -->
    <selectpopupinvoice v-if="popupstate" @onselectpopup="onselectpopup" title="申请重开发票须知"/>
    <selectpopup v-if="reTryPopupstate" @onselectpopup="retryonselectpopup" title="再次提交" content="是否确定要再次提交 ？"/>
  </div>
</template>

<script>
import { getGuideInfo } from '@/service/user/user.js';
import { getInvoiceApplyList } from '@/service/invoice/list.js';
import { invoiceDetail } from '@/service/invoice/detail.js';
import { InvoiceRetry } from '@/service/invoice/apply.js'
export default {
  name: 'myinvoice',
  data() {
    return {
      currentIndex: 0,
      isGroup:false,
      perPageSize: 10,
      pageNo: 1,
      loadMore:true,// 第一次加载数据时的正在加载
      loadMoreing:true,// 上拉加载数据时的正在加载
      userInfo: {},
      invoiceData: [],
      popupstate:false,
      reTryPopupstate:false,
      invoiceRow: {}
    }
  },
  created () {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    this.judgeGroup()
  },
  mounted () {
    let onScroll = window.addEventListener('scroll', this.scrollRun);// 监听滚动
    this.pageNo = 1
    this.getData();
  },
  methods: {
    clickCurrent(index){
      if(this.currentIndex === index)return;
      this.currentIndex = index;
      this.pageNo = 1
      // this.individualOrderInfos = [];
      this.getData();
    },
    async judgeGroup() {
         // 2023-09-05 jushuai 更改begin
      // const voucher = JSON.parse(window.localStorage.getItem('userInfo'));
      // let userInfo = null;
      // userInfo = JSON.parse(sessionStorage.getItem('groupUserInfo')) || null;
      let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      // if(!userInfo){
      //   const { data } = await getGuideInfo.call(this, {
      //     userType: 'weixin',
      //     userId: voucher.userId
      //   });
      //   userInfo = data;
      // };
      if(userInfo.extField1){
        this.isGroup = true
      }else{
        this.isGroup = false
      }
    },
    async getData () {
      const parameter = {
          userId: this.userInfo.userId,
          perPageSize: this.perPageSize,
          pageNo: this.pageNo
      };
      if(this.isGroup) {
        if(this.currentIndex) {
          parameter.orderType = 'INDI'
        }else{
          parameter.orderType = 'GROUP'
        }
      }else{
        parameter.orderType = 'INDI'
      }
      const { data } = await getInvoiceApplyList.call(this, parameter);
      if(data.infoList.length != 0) {
      if(this.pageNo==1){// 当加载第1页数据时
            this.invoiceData = []// 第1页清空数据
            if(data.infoList.length>0){// 如果第1页数据条数大于0
                  this.invoiceData = [...this.invoiceData,...data.infoList]
                this.loadMore = true;// 显示正在加载(在屏幕底部以外)
            }else{
                this.loadMore = false;// 没有数据则隐藏正在加载
            }
        }else{// 当加载第2页及其以后的数据时
             if(data.infoList.length>0){// 如果第1页数据条数大于0
                  this.invoiceData = [...this.invoiceData,...data.infoList]
                this.loadMore = true;// 显示正在加载(在屏幕底部以外)
            }else{
                this.loadMore = false;// 没有数据则隐藏正在加载
            }
        }
        //如果总页数==当前页=>没有更多数据了
        if(data.totalCount==this.invoiceData.length){
            this.loadMore = false;
            this.loadMoreing = false;
        }
        
      }
      
    },
    searchInvoice(url,type){
      if(type == 2){
        window.location.href = url
      }else{
        // window.location.href = process.env.VUE_APP_INVOICE_SD_URL + url
        // this.$router.push({path:'/pdf/show',query:{ url: process.env.VUE_APP_INVOICE_SD_URL + url }})
        window.open(process.env.VUE_APP_INVOICE_SD_URL + url)
      }
    },
    toDetail(id) {
      this.$router.push({path:'/invoicedetail',query:{ id }});
    },
    toMakeInvoice() {
      this.$router.push(`/makeinvoice`);
    },
    async reTrySubmit(item) {
      // this.reTryPopupstate = true
      // this.invoiceRow = item
       const parameter = {
          id:item.id,
      };
      const { data } = await invoiceDetail.call(this, parameter);

      //  const SelectedInvoiceOrderList = []
      // for(let item of this.selectedRows) {
      //   SelectedInvoiceOrderList.push(item.orderId)
      // }
      // window.sessionStorage.setItem('InvoiceOrderList', JSON.stringify(SelectedInvoiceOrderList));

      const baseInfo = {
        orderType: item.orderType,
        orderCount: data.detailList.length,
        totalPrice: data.totalAmount
      }
      window.sessionStorage.setItem('baseInfo', JSON.stringify(baseInfo));
      item.type = item.invoiceHeader
      if(item.reserve1 != "") {
         item.address = JSON.parse(item.reserve1).address
        item.accountName = JSON.parse(item.reserve1).accountName
        item.phone = JSON.parse(item.reserve1).phone
        item.accountNo = JSON.parse(item.reserve1).accountNo
      }


      window.sessionStorage.setItem('selectedInvoiceTitle', JSON.stringify(item));

       this.$router.push(`/alignWirteInvoice`);

    },
    async toChangeInvoice(item) {
      // console.log(item)

      const parameter = {
          id:item.id,
      };
      const { data } = await invoiceDetail.call(this, parameter);
      //  const SelectedInvoiceOrderList = []
      // for(let item of this.selectedRows) {
      //   SelectedInvoiceOrderList.push(item.orderId)
      // }
      // window.sessionStorage.setItem('InvoiceOrderList', JSON.stringify(SelectedInvoiceOrderList));

      const baseInfo = {
        orderType: item.orderType,
        orderCount: data.detailList.length,
        totalPrice: data.totalAmount
      }
      window.sessionStorage.setItem('baseInfo', JSON.stringify(baseInfo));
      item.type = item.invoiceHeader
      if(item.reserve1 != "") {
        item.address = JSON.parse(item.reserve1).address
        item.accountName = JSON.parse(item.reserve1).accountName
        item.phone = JSON.parse(item.reserve1).phone
        item.accountNo = JSON.parse(item.reserve1).accountNo
      }
      // console.log(item)

      window.sessionStorage.setItem('selectedInvoiceTitle', JSON.stringify(item));
      this.popupstate = true
    },
    async retryonselectpopup(state) {
      if(state === 'determine'){

        this.$throttle(this._retryInvoice(),3000)

      }
      this.$store.commit('setWindowMaskEl', null)
      this.reTryPopupstate = false;
    },
    async _retryInvoice() {
      const parameter = {
          applyId: this.invoiceRow.id
        }
        const res =await InvoiceRetry.call(this, parameter);
        // console.log(res)
        if(res.errorMessage == '') {
        this.$toast(`提交成功`);
        this.invoiceRow == {}
        this.getData();
      }
    },
    onselectpopup(state) {
      if(state === 'determine'){
        this.$router.push(`/wirteInvoiceName`);
      }
      this.$store.commit('setWindowMaskEl', null)
      this.popupstate = false;
    },
    scrollRun(){// 核心代码
        if(this.loadMore == true&&!!document.getElementById("loadMore")){//如果总共有一页以上数据，才运行
            let bodyWidth = document.body.offsetWidth;
            let bodyHeight = window.innerHeight*(375/bodyWidth);// 以6s屏幕为基准比例
            let loadMoreTop = document.getElementById("loadMore").getBoundingClientRect().top*(375/bodyWidth);//loadMore距离顶部的距离
  
            if(bodyHeight-loadMoreTop>20){//loadMore被拉出底部20px时
                // console.log("bodyHeight",bodyHeight,"loadMoreTop",loadMoreTop,"差值",bodyHeight-loadMoreTop,"页码",this.dataCurPage+1);
                this.loadMore = false;//停止运行scrollRun，否则会触发加载所有页面
                this.getData(this.pageNo++);
            }
        }
    },
  }
}
</script>

<style scoped lang='less'>
.tbp {
  padding-top: 1.2rem;
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
  overflow-y:hidden;
}
.tbpIn{
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
  overflow-y:hidden;
}
.list{
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
}
.list>ul{
    padding: 0 .4rem;
    line-height: .64rem * 2;
    display: flex;
    background: #FFFFFF;
    justify-content: space-between;
    color: #333333;
    font-size: .213333rem * 2;
    li{
      flex: 1;
      text-align: center;
    }
    .active{
      // color: #3A3F5C;
      font-weight: 500;
      position: relative;
      &::after{
        content: '';
        position: absolute;
        bottom: .106667rem;
        left: 50%;
        transform: translateX(-50%);
        width: 1.6rem;
        height: .08rem;
        background: #3B6D9C;
        border-radius: .08rem;
      }
    }
}
.item{
  background: #FFFFFF;
  // background: red;
  padding-bottom: .346667rem;
  margin: (.533333rem / 2);
  border-radius: .266667rem;

  .content{
    padding: 0.533333rem .546667rem;
    display: flex;
    flex-direction: column;
    .firstrow{
      display: flex;
      justify-content: space-between;
      padding-bottom: .133333rem;
      .createtime{
        font-size: .48rem;
        font-weight: 500;
      }
      .status{
        font-size: .4rem;
        span{
          margin-right: .133333rem;
        }
        img{
          width: .173333rem;
        }
      }
    }
    .secondrow{
      display: flex;
      justify-content: space-between;
      .ticket{
        .invoice{
          background-color: rgba(218, 54, 45, 0.2);
          margin-right: .266667rem;
          border-radius: .066667rem;
          i {
            font-size: .32rem;
            color:#3B6D9C;
          }
        }
        .park-ticket{
          font-size: .4rem;
        }
      }
      .price{
        font-size: .48rem;
        font-weight: bold;
        color: #3B6D9C;
      }
    }
  }
  .option{
    padding: 0 .346667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: .32rem;
    margin-bottom: .1rem;
    button{
      border-radius: .186667rem * 2;
      padding: 0 .293333rem * 2;
      line-height: .373333rem * 2;
      font-size: .32rem;
    }
    div>button:first-child{
      border:.013333rem solid #3B6D9C;
      color: #3B6D9C;
    }
    div>button{
      border:.013333rem solid #3B6D9C;
      color: #3B6D9C;
      margin-left: .266667rem;
    }
  }
}
.bottom{
  height: 1.6rem + .346667rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: rgb(248, 248, 248);
  .continue{
  position: fixed;
  margin: auto;
  width: 98%;
  bottom: .266667rem;
  left: 0;
  right: 0;
  background: #3B6D9C;
  line-height: 1.2rem;
  border-radius: 1.333333rem;
  text-align: center;
  color: #FFFFFF;
  font-size: .48rem;
}
}

</style>
